import { Checkbox } from "@visiblethread/react-components";
import clsx from "clsx";
import PropTypes, { func } from "prop-types";
import handleKeyboardClick from "utils/handleKeyboardClick";

import { getCheckboxState } from "../helpers";
import styles from "./SelectAllCheckboxCell.module.scss";

const SelectAllCheckboxCell = ({ onUpdate, table }) => {
  const isAllSelected = table.getIsAllPageRowsSelected();
  const isSomeSelected = table.getIsSomePageRowsSelected();
  const hasSelectableRows = table
    .getRowModel()
    .rows.some((row) => row.getCanSelect());

  const onChange = (e) => {
    e.stopPropagation();
    table.getToggleAllPageRowsSelectedHandler()(e);

    if (onUpdate) {
      onUpdate(!isAllSelected);
    }
  };

  if (!hasSelectableRows) {
    return null;
  }

  return (
    <div
      className={clsx("row_checkbox", {
        "is-selected": isAllSelected || isSomeSelected,
      })}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={handleKeyboardClick((e) => e.stopPropagation())}
    >
      <Checkbox
        className={clsx(styles.row_checkbox, {
          [styles["is-selected"]]: isAllSelected || isSomeSelected,
        })}
        id="select-all-checkbox"
        state={getCheckboxState(isAllSelected, isSomeSelected)}
        handleChange={onChange}
      />
    </div>
  );
};

SelectAllCheckboxCell.propTypes = {
  onUpdate: func,
  table: PropTypes.object.isRequired,
};

export default SelectAllCheckboxCell;
